import { Box } from '@pets-ui/Box/Box'
import { Image } from '@pets-ui/Image/Image'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import rankBronzeImage from '../../assets/rank-bronze.png'
import rankGoldImage from '../../assets/rank-gold.png'
import rankNormalImage from '../../assets/rank-normal.png'
import rankSilverImage from '../../assets/rank-silver.png'
import { type ProductCardEntry } from '../types/product-card-entry'
import { ProductCard } from './ProductCard'

const rankImageMap: Record<number, string> = {
  1: rankGoldImage,
  2: rankSilverImage,
  3: rankBronzeImage,
}

interface RankedProductCardProps {
  rank: number
  entry: ProductCardEntry
  onSelect: (entry: ProductCardEntry) => void
}

export const RankedProductCard = (props: RankedProductCardProps) => {
  const { rank, entry, onSelect } = props

  return (
    <Box position="relative">
      <Box position="absolute" top={0} left={0} width={28} height={28} zIndex={1}>
        <Image src={rankImageMap[rank] ?? rankNormalImage} alt={`rank-${rank}`} width={28} height={28} />
        <Box position="absolute" left="50%" top="calc(50% - 4px)" transform="translate(-50%, -50%)">
          <Text variant="subtitle" bold color={colors.white}>{rank}</Text>
        </Box>
      </Box>
      <ProductCard entry={entry} onSelect={onSelect} hideBadge />
    </Box>
  )
}
